import { useEffect, useState } from "react";
import { v4 as uuid } from "uuid";
import { IContainerApp } from "../../navigationButtonComponents/loansTab/containerApp/IContainerApp";
import ApplyRequestSteps from "./applyRequestSteps/applyRequestSteps";
import IdentityInformation from "../identity/identityInformation";
import ResidenceInformation from "../residence/residenceInformation";
import JobInformation from "../../jobInformation/jobInformation";
import WaitCheque from "../cheques/waitCheque";
import { TInnerStateForm } from "./IFormInnerState";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import GuarantorContainer from "../../navigationButtonComponents/guarantorContainer/guarantorContainer";
import WaitSign from "../../signContract/waitSign";
import KycVideo from "../../videoAuthorization/kycVideo";
import DrawerBody from "../drawerBody/drawerBody";
import LayoutWithoutDrawer from "../../../layouts/LayoutWithoutDrawer";
import AdditionalFields from "../additionInfo/additionalFields";
import AdditionalStep from "../additionInfo/additionalStep";
export default function WaitCustomersDocument({ referenceKey, setStep }: IContainerApp) {
    const [formInnerState, setFormInnerState] = useState<TInnerStateForm>('formList');
    const stateFromRedux = useSelector((state: RootState) => state.prevAndNextState.nextInnerState) as TInnerStateForm;
    useEffect(() => {
        if (stateFromRedux.includes('formList'))
            setFormInnerState('formList')
    }, [stateFromRedux])
    const innerStep = {
        'formList':
            <DrawerBody>
                <ApplyRequestSteps referenceKey={referenceKey} setFormInnerState={setFormInnerState} setStep={setStep} />
            </DrawerBody>
        ,
        'Identity': <DrawerBody>
            <IdentityInformation referenceKey={referenceKey} setFormInnerState={setFormInnerState} setStep={setStep} />
        </DrawerBody>,
        'KycVideo': <LayoutWithoutDrawer>
            <KycVideo referenceKey={referenceKey} setFormInnerState={setFormInnerState} setStep={setStep} />
        </LayoutWithoutDrawer>,
        'Residential': <DrawerBody>
            <ResidenceInformation referenceKey={referenceKey} setFormInnerState={setFormInnerState} setStep={setStep} />
        </DrawerBody>,
        'Incomes': <DrawerBody>
            <JobInformation referenceKey={referenceKey} setFormInnerState={setFormInnerState} setStep={setStep} />
        </DrawerBody>,
        'Cheque': <DrawerBody>
            <WaitCheque setFormInnerState={setFormInnerState} setStep={setStep} referenceKey={referenceKey} />
        </DrawerBody>,
        'Guarantors': <DrawerBody>
            <GuarantorContainer setFormInnerState={setFormInnerState} setStep={setStep} referenceKey={referenceKey} />
        </DrawerBody>,
        'AdditionalFields': <DrawerBody>
            <AdditionalFields setFormInnerState={setFormInnerState} setStep={setStep} referenceKey={referenceKey} />
        </DrawerBody>,
    }
    return (
        <div>
            {innerStep[formInnerState!]}
        </div>
    )
}
